import { render, staticRenderFns } from "./ServiceRequestView.vue?vue&type=template&id=79531a4c"
import script from "./ServiceRequestView.vue?vue&type=script&lang=js"
export * from "./ServiceRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports